import HistoryOutlinedIcon from "@material-ui/icons/HistoryOutlined";
import { LocationsHistoryView } from "./LocationsHistoryView";

export default {
  icon: HistoryOutlinedIcon,
  list: LocationsHistoryView,
};
